import ContinuePage from "@components/ContinuePage"
import { isHomeDesignFlow } from "@helpers/localStorage"

export default function AlmostTherePage() {
  if (isHomeDesignFlow()) {
    return <ContinuePage emoji="🏠" translationKey="almostThereHomeDesign" />
  }
  return <ContinuePage emoji="🚀" translationKey="almostThere" />
}
